(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bavi-ugc-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('{{ section_id }}');
    if (!root || root.dataset.ugcReady === 'true') return;
    root.dataset.ugcReady = 'true';
    root.querySelectorAll('[data-ugc-external-url]').forEach((image) => {
      try {
        const url = new URL(image.dataset.ugcExternalUrl);
        let videoId = url.searchParams.get('v');
        if (!videoId && (url.hostname === 'youtu.be' || url.hostname.endsWith('.youtu.be'))) videoId = url.pathname.split('/').filter(Boolean)[0];
        if (!videoId && url.hostname.includes('youtube.com')) videoId = url.pathname.split('/').filter(Boolean)[1];
        if (videoId && /^[A-Za-z0-9_-]{11}$/.test(videoId)) image.src = 'https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg';
        else image.remove();
      } catch (error) {
        image.remove();
      }
    });
    const track = root.querySelector('.bavi-ugc__track');
    root.querySelectorAll('[data-ugc-open]').forEach((trigger) => {
      const modal = root.querySelector('[data-ugc-modal="' + trigger.dataset.ugcOpen + '"]');
      if (!modal) return;
      const video = modal.querySelector('video');
      const close = () => { if (video) { video.pause(); video.currentTime = 0; } modal.hidden = true; modal.setAttribute('aria-hidden', 'true'); trigger.focus(); };
      trigger.addEventListener('click', () => { modal.hidden = false; modal.setAttribute('aria-hidden', 'false'); if (video) video.play().catch(() => {}); });
      modal.querySelectorAll('[data-ugc-close]').forEach((button) => button.addEventListener('click', close));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sticky-preorder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-home-sticky-preorder]').forEach((sticky) => {
      if (sticky.dataset.visibilityReady) return;
      sticky.dataset.visibilityReady = 'true';
      if (sticky.dataset.stickyMode !== 'after-first') return;
      const main = document.getElementById('MainContent');
      const first = main && Array.from(main.children).find((el) =>
        el.matches('.shopify-section') && el.getBoundingClientRect().height > 0);
      if (!first) return;
      let queued = false;
      const check = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          sticky.classList.toggle('is-visible', first.getBoundingClientRect().bottom <= 0);
        });
      };
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
